import React from "react";  



export default function TemplteError (props){
 return(
    <>
  
    <p>Name: {props.name}  Component Not Found!</p>
    </>
 )
}